<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'IconOption',
})
</script>
<template>
  <div :class="bem({ selected, active, disabled, monospace, ellipsis })">
    <i v-if="icon" :class="[bem('icon'), 'iconfont', icon]" />
    <span :class="bem('label')"><slot /></span>
  </div>
</template>

<script lang="ts" setup name="IconOption">
import { createNamespace } from '@bd/vue3-utils'
import { iconOptionProps } from './props'

const [_, bem] = createNamespace('IconOption')
defineProps(iconOptionProps)
</script>

<style lang="less">
@ns: icon-option;
.@{ns} {
  display: flex;
  align-items: flex-start;
  min-height: 32px;
  padding: 5px 12px;
  font-size: 14px;
  line-height: 22px;
  transition: background 0.3s ease;
  cursor: pointer;

  &:hover:not(&--disabled),
  &--active {
    background: #f5f5f5;
  }

  &--disabled {
    color: #bfbfbf;
    cursor: not-allowed;
  }

  &--selected:not(&--disabled) {
    background-color: #e6f6ff;
  }

  &--monospace {
    .@{ns}__label {
      .monospace-font();
    }
  }

  &--ellipsis {
    .@{ns}__label {
      .text-show-row(22px);
    }
  }

  &__icon {
    margin-right: @margin-xs;
    color: @text-color-secondary;
    font-size: 14px;
  }

  &__label {
    flex: 1;
    white-space: wrap;
    word-break: break-all;
  }
}
</style>
